import { siteInfo } from "@/mocks/comicData";

const heroStats = [
  { value: "主角", label: "林屿 · 17岁" },
  { value: "继母", label: "苏婉 · 设计师" },
  { value: "继姐", label: "苏念 · 职场人" },
];

export default function Hero() {
  return (
    <section id="hero" className="relative flex min-h-[92vh] items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20warm%20slice-of-life%20manga%20illustration%2C%20a%20cozy%20sunlit%20living%20room%20with%20a%20blended%20family%20gathered%20around%20a%20low%20wooden%20table%20sharing%20tea%20and%20laughter%2C%20a%20gentle%20stepmother%20and%20stepsister%20and%20a%20young%20protagonist%2C%20soft%20cream%20terracotta%20and%20warm%20amber%20palette%2C%20painterly%20pastel%20anime%20background%20art%20with%20soft%20window%20light%20and%20warm%20shadows%2C%20no%20text&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="继母与继姐漫画 重组家庭的温暖日常背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-24 text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 border border-background-50/30 px-4 py-1.5 text-xs md:text-sm font-medium text-background-50 backdrop-blur">
          <i className="ri-book-open-line w-4 h-4 flex items-center justify-center"></i>
          角色关系聚合指南
        </span>

        <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black leading-tight text-background-50">
          继母与继姐漫画
        </h1>
        <p className="mt-4 font-heading text-lg md:text-2xl font-medium text-accent-200">
          「{siteInfo.tagline}」
        </p>
        <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-background-100/90">
          一次看懂主角介绍、继母与继姐角色设定，以及贯穿全篇的人物关系与互动逻辑。从陌生隔阂到真正成为一家人，这里为你把每一段关系都梳理清楚。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#protagonist"
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors"
          >
            认识主角林屿
          </a>
          <a
            href="#relationships"
            className="whitespace-nowrap rounded-md bg-background-50/15 border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-background-50/25 transition-colors"
          >
            查看人物关系图
          </a>
        </div>

        <div className="mt-12 grid w-full max-w-xl grid-cols-3 gap-3">
          {heroStats.map((stat) => (
            <div
              key={stat.value}
              className="rounded-lg bg-background-50/10 border border-background-50/20 px-3 py-4 backdrop-blur"
            >
              <div className="text-sm md:text-base font-bold text-accent-200">{stat.value}</div>
              <div className="mt-1 text-xs md:text-sm text-background-100/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <a
        href="#protagonist"
        aria-label="向下滚动"
        className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 grid h-10 w-10 place-items-center rounded-full border border-background-50/40 text-background-50 animate-bounce"
      >
        <i className="ri-arrow-down-line"></i>
      </a>
    </section>
  );
}